import { RotateCcw } from "lucide-react";

export const MatchedAgenciesHeader = ({ groups, skipped, onRestore, onRestoreAll }) => {
  const hidden = groups.filter((g) => skipped.has(g.group_id));
  const shown = groups.length - hidden.length;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="bulk-matched-header">
      <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-[#6B6B61]" data-testid="bulk-matched-count">
        Matched Agencies · {hidden.length ? `${shown} of ${groups.length}` : groups.length}
      </span>
      {hidden.length > 0 && (
        <>
          <span className="text-[10px] font-mono uppercase tracking-wider text-[#8A6046]">· Hidden:</span>
          {hidden.map((g) => (
            <button
              key={g.group_id}
              type="button"
              onClick={() => onRestore(g.group_id)}
              data-testid={`bulk-agency-restore-${g.group_id}`}
              title="Wapas lao"
              className="inline-flex items-center gap-1 px-2 py-0.5 rounded border border-[#8A6046]/40 bg-[#8A6046]/10 text-[10px] font-mono text-[#8A6046] hover:bg-[#8A6046]/20 transition-colors"
            >
              {g.group_name}
              <RotateCcw className="w-3 h-3" />
            </button>
          ))}
          {hidden.length > 1 && (
            <button
              type="button"
              onClick={onRestoreAll}
              data-testid="bulk-agency-restore-all"
              className="text-[10px] font-mono uppercase tracking-wider text-[#385C4B] underline hover:text-[#2A4538]"
            >
              Show all
            </button>
          )}
        </>
      )}
    </div>
  );
};
